var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { AsciiText } from './framework/AsciiText';
import { ViscaBase } from './util/ViscaBase';
export class ViscaUdp extends ViscaBase {
    // other class properties and constructor
    constructor(socket, state, log, framework) {
        super(ViscaUdp.driverType, state, log, framework);
        this.socket = socket;
    }
    // controls
    // phase callbacks
    // other class methods
    makeCommand(data) {
        const bytes = [];
        bytes.push(1); // Byte 0 of UDP header
        bytes.push(data[1] === 1 ? 0x00 : 0x10); // Byte 1 of header based on VISCA command or query
        bytes.push(0); // high byte of VISCA command length
        bytes.push(data.length + 1); // low byte of length including 0xFF command terminator to be added
        bytes.push(0, 0, 0, 0); // command sequence
        bytes.push(...data); // Payload with VISCA command data
        bytes.push(0xff); // Visca command terminator
        return AsciiText.decode(bytes);
    }
    registerAsync(match, callback, name) {
        return this.socket.registerAsync({ match, callback, name });
    }
    send(bytes, match, tags, options) {
        return __awaiter(this, void 0, void 0, function* () {
            const resp = yield this.socket.send(this.makeCommand(bytes), (resp) => {
                return match(resp.command);
            }, tags, options);
            return resp.command;
        });
    }
    setIdleTimeoutMs(timeoutMs) {
        this.socket.setIdleTimeoutMs(timeoutMs);
    }
}
// static properties
ViscaUdp.driverType = 'udpDriver';
ViscaUdp.key = '-NVept1aZ-gBDJ5mhjaz';
ViscaUdp.socketOptions = (config) => {
    var _a;
    return [
        {
            isBinary: true,
            logReceivedData: true,
            parser: (address, port, command) => {
                // Remove 8 byte header and 0xff terminator.
                return command.slice(8, command.length - 1);
            },
            port: (_a = config.port) !== null && _a !== void 0 ? _a : 52381,
        },
    ];
};
